<template>
    <div class="container" style="background-color: #264740;">
        <Orangedot style="margin: 5px 0 0 0" />
        <Orangedot style="margin: 60px 0 0 140px" />
        <div class="bien"
            style="color:#fff;display:flex;justify-content: flex-start;align-items: center;font-size: 80px;text-transform: capitalize;margin: 0;height: 100px;">
            Bien</div>
        <Orangedot style="margin: 60px 0 0  90px" />
        <div class="venue"
            style="color:#fff;display:flex;justify-content: flex-start;align-items: center;font-size: 80px;margin: 0;height: 100px;transform: rotate(3deg);">
            venue</div>

    </div>
</template>
<script>
import Orangedot from './Orangedot.vue';

export default {
    name: 'Bienvenue',

    components:{
        Orangedot
    }
}
</script>